import React, { PureComponent } from 'react';

import RfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';
import MaterialTable from 'material-table';
import Zoom from '@material-ui/core/Zoom';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import { AttachFile } from '@material-ui/icons';
import {
  Badge,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  TextField,
  Button,
  Grid,
  Typography,
  InputAdornment
} from '@material-ui/core';
import { Close as CloseIcon, Print } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import tableIcons from '../../../utils/editTableIcons';
import { CurrentAwb } from '../../../models/OfflineRfs';
import Awb from '../../../models/Awb';
import { connect } from 'react-redux';
import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import ResponseError from '../../../models/ResponseError';
import offlineRfsRemote from '../../../api/offlineRfsRemote';
import awbRemote from '../../../api/awbRemote';
import ApiResponse from '../../../models/ApiResponse';
import validation from '../../../utils/validation';
import addIcon from '../../../assets/add.svg';

const styles = (theme: Theme) =>
  createStyles({
    PoD: {
      color: '#rgb(0, 50, 97)',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    awbActionsList: {
      display: 'flex',
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-around',
    },
    backdrop: {
      backgroundColor: "transparent"
    },
    actionMaterialIcon:{
      fontSize: '20px'
    },
    DialogContent: {
      paddingTop: '10px'
    },
    addAwbContainer: {
      padding: '15px',
      marginBottom: '15px',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      border: '1px solid #eee'
    },
    addButton: {
      marginTop: '10px',
    }
  });

interface rowAwb {
  id: number;
  awb: string;
  destination: string;
  number: string;
  origin: string;
  pieces: string;
  weight: string;
  org: string;
  dst: string;
  special: string;
  returned: boolean;
  manually_entered: boolean;
}

interface NewAwbState {
  awbNumberInput: string;
  code: string;
  number: string;
  version: number;
  org: string;
  dst: string;
  pieces: string;
  weight: string;
  special: string;
  remarks: string;
  manualEntry: boolean;
}

interface AwbsTableState {
  offlineAwbs: CurrentAwb[];
  newAwb: NewAwbState;
};

interface AwbsTableProps {
  classes: any;
  selectedOrderNumber?: number;
  modalOpen: boolean;
  receiveSuccess: Function;
  receiveError: Function;
  handleClose: (type: string) => void;
  openAttachments: (awb: string, version: number) => void;
  printAwbInfoClicked: (awb: string, version: number) => void;
};

const INITIAL_NEW_AWB: NewAwbState = {
  awbNumberInput: '',
  version: 0,
  code: '',
  number: '',
  org: '',
  dst: '',
  pieces: '',
  weight: '',
  special: '',
  remarks: '',
  manualEntry: false
};

class AwbsTable extends PureComponent<AwbsTableProps, AwbsTableState> {
  state: AwbsTableState = {
    offlineAwbs: [],
    newAwb: { ...INITIAL_NEW_AWB }
  }
  
  componentDidMount() {
    this.getOrderAwbs();
  }

  getOrderAwbs = () => {
    if(this.props.selectedOrderNumber) {
      offlineRfsRemote.getOfflineOrderAwbs(this.props.selectedOrderNumber.toString()).then((resp: ApiResponse<any[]>) => {

        const awbs: CurrentAwb[] | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (awbs) {
          this.setState({ offlineAwbs: awbs });
        } 
        
        if (error) {
          this.props.receiveError(error);
        }
      });
    }
    
  }

  handleAwbChange = (field: keyof NewAwbState, value: string) => {
    this.setState(prevState => ({
      newAwb: {
        ...prevState.newAwb,
        [field]: value
      }
    }));
  }

  handleAwbInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    const { awbNumberInput } = this.state.newAwb;

    if (value.length === 3 && awbNumberInput.length === 2) {
      value = value + '-';
    }
    if (value.length === 11) {
      if (value.indexOf('-') < 0) {
        value = value.slice(0 , 3) + '-' + value.slice(3);
      }
    }
    if (value.split('-').length > 2) {
      return;
    }
    this.handleAwbChange('awbNumberInput', value);
  }

  handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      this.handleSearchAwb();
    }
  }

  handleSearchAwb = () => {
    const { awbNumberInput } = this.state.newAwb;

    if (validation.validateAWB(awbNumberInput)) {
      const isExport = true; 
      
      // Reset fields before search
      this.setState(prevState => ({
        newAwb: { ...prevState.newAwb, code: '', number: '', org: '', dst: '', pieces: '', weight: '', manualEntry: false } 
      }));

      awbRemote.extractNewAwb(awbNumberInput, 'export', isExport).then((resp: { awbData: Awb, requestId: string }) => {
        this.setState(prevState => ({
          newAwb: {
            ...prevState.newAwb,
            code: resp.awbData.code,
            number: resp.awbData.number,
            org: resp.awbData.origin,
            version: resp.awbData.version,
            dst: resp.awbData.destination,
            pieces: String(resp.awbData.pieces),
            weight: String(resp.awbData.weight),
            manualEntry: false
          }
        }));
      }, (err) => {
         if (err.errorCode === '#couldntExtractAWBInfo' || err.errorCode === '#airwayCodeNotFound') {
            const parts = awbNumberInput.split('-');
            this.setState(prevState => ({
              newAwb: {
                ...prevState.newAwb,
                code: parts[0] || '',
                number: parts[1] || '',
                manualEntry: true
              }
            }));
         } else {
            this.props.receiveError(err);
         }
      });
    } else {
         this.props.receiveError({ longDescription: 'Invalid AWB Format (XXX-XXXXXXXX)' } as ResponseError);
    }
  }

  handleAddAwb = () => {
    const { newAwb } = this.state;
    
    // If manual entry or search result, we use code/number. If manual entry, code/number should be set from split
    let code = newAwb.code;
    let number = newAwb.number;

    if (!code || !number) {
       const parts = newAwb.awbNumberInput.split('-');
       if (parts.length === 2) {
         code = parts[0];
         number = parts[1];
       }
    }
    
    if (!code || !number || !newAwb.pieces || !newAwb.weight || !newAwb.org || !newAwb.dst) {
       this.props.receiveError({ longDescription: 'Please fill in all required fields' } as ResponseError);
       return;
    }

    const awbToAdd: CurrentAwb = {
        awb: `${code}-${number}`,
        version: newAwb.version, 
        org: newAwb.org.toUpperCase(),
        dst: newAwb.dst.toUpperCase(),
        pieces: newAwb.pieces,
        weight: newAwb.weight,
        special: newAwb.special,
        remarks: newAwb.remarks,
        focused: false,
        wghFocused: false
    };

    if (this.props.selectedOrderNumber) {
        offlineRfsRemote.saveRfsAwbToOrder([awbToAdd], this.props.selectedOrderNumber).then(resp => {
            if (resp.result) {
                this.props.receiveSuccess("AWB Added successfully");
                this.getOrderAwbs();
                this.setState({ newAwb: { ...INITIAL_NEW_AWB } });
            }
            if (resp.error) {
                this.props.receiveError(resp.error);
            }
        });
    }
  }
  
  render() {
    const { newAwb } = this.state;
    const isManualOrEmpty = !newAwb.code || newAwb.manualEntry;
    // Fields are disabled if we found data (manualEntry is false) AND we have code (meaning search success).
    // So: disabled = !manualEntry && code !== ''
    // Wait, if search success, code is set and manualEntry is false. We want fields disabled.
    // If search fail, code might be set from split, but manualEntry is true. We want fields enabled.
    const fieldsDisabled = !newAwb.manualEntry && newAwb.code !== '';

    return (
      <Dialog
        open={ this.props.modalOpen }
        onClose={ () => this.props.handleClose('viewAwbs') }
        aria-labelledby='form-dialog-title'
        maxWidth={'lg'}
        TransitionComponent={ Zoom }
        transitionDuration={ 500 }
        style={{ zIndex: 10 }} // Ensure dialog is below attachment drawer
        >
        <DialogTitle id='form-dialog-title'>
          <div className={ RfsStyles.dialogTitle }>
            <span className={ RfsStyles.awbModalName }>View AWB's</span>
            <IconButton
              aria-label='Close'
              className={ RfsStyles.close }
              onClick={ () => this.props.handleClose('viewAwbs') }>
              <CloseIcon color='primary' />
            </IconButton>
          </div>
          <hr />
        </DialogTitle>
        <DialogContent className={ RfsStyles.DialogContent}>
          <div className={ commonStyles.wrapper}>
            <h3 className={commonStyles.header}> Add New AWB</h3> 
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3}>
                <TextField 
                  label="Airwaybill Number" 
                  variant="outlined" 
                  fullWidth
                  value={newAwb.awbNumberInput} 
                  onChange={this.handleAwbInput}
                  onKeyDown={this.handleKeyDown}
                  className={commonStyles.customTextField}
                  InputProps={{
                    classes: { notchedOutline: commonStyles.noNotch },
                    endAdornment: (
                      <InputAdornment position="end">
                         <SearchIcon 
                           onClick={this.handleSearchAwb} 
                           style={{ cursor: 'pointer', color: 'var(--primaryblue)' }}
                         />
                      </InputAdornment>
                    )
                  }}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                />
              </Grid>
              <Grid item xs={2} sm={1}>
                <TextField 
                  label="Org" 
                  variant="outlined" 
                  value={newAwb.org} 
                  onChange={(e) => this.handleAwbChange('org', e.target.value)} 
                  disabled={fieldsDisabled}
                  InputProps={{ 
                    classes: { notchedOutline: commonStyles.noNotch },
                    inputProps: { maxLength: 3, style: { textTransform: 'uppercase' } } 
                  }}
                  className={commonStyles.customTextField} 
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                />
              </Grid>
              <Grid item xs={2} sm={1}>
                <TextField 
                  label="Dst" 
                  variant="outlined" 
                  value={newAwb.dst} 
                  onChange={(e) => this.handleAwbChange('dst', e.target.value)} 
                  disabled={fieldsDisabled}
                  InputProps={{ 
                    classes: { notchedOutline: commonStyles.noNotch },
                    inputProps: { maxLength: 3, style: { textTransform: 'uppercase' } } 
                  }}
                  className={commonStyles.customTextField} 
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                />
              </Grid>
              <Grid item xs={2} sm={1}>
                <TextField 
                  label="Pcs" 
                  variant="outlined" 
                  type="number" 
                  disabled={fieldsDisabled}
                  value={newAwb.pieces} 
                  onChange={(e) => this.handleAwbChange('pieces', e.target.value)}
                  className={commonStyles.customTextField} 
                  InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                />
              </Grid>
               <Grid item xs={2} sm={2}>
                <TextField 
                  label="Weight (kg)" 
                  variant="outlined" 
                  type="number" 
                  disabled={fieldsDisabled}
                  value={newAwb.weight} 
                  onChange={(e) => this.handleAwbChange('weight', e.target.value)} 
                  className={commonStyles.customTextField} 
                  InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                />
              </Grid>
              <Grid item xs={2} sm={1}>
                 <TextField 
                  label="Special" 
                  variant="outlined" 
                  value={newAwb.special} 
                  onChange={(e) => this.handleAwbChange('special', e.target.value)} 
                  className={commonStyles.customTextField} 
                  InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                 />
              </Grid>
               <Grid item xs={3} sm={2}>
                 <TextField 
                  label="Remarks" 
                  variant="outlined" 
                  value={newAwb.remarks} 
                  onChange={(e) => this.handleAwbChange('remarks', e.target.value)}
                  className={commonStyles.customTextField} 
                  InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }} 
                 />
              </Grid>
              <Grid item xs={'auto'}>
                <IconButton
                  onClick={this.handleAddAwb}
                  size="small"
                  title="Add Awb"
                  className={this.props.classes.addButton}
                >
                  <img alt="add" src={addIcon} width={24} 
                  />
                </IconButton>
              </Grid>
            </Grid>
          </div>

          <div className={ `${ commonStyles.wrapper } ${ RfsStyles.tblWrapper }` }>

            <h3 className={ commonStyles.header }>Orders</h3>
            <MaterialTable
              components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
              icons={ tableIcons }
              data={ this.state.offlineAwbs }
              columns={[
                {
                  title: 'Airwaybill',
                  field: '',
                  cellStyle: { width: '120px' },
                  render: (rowData: any) => {
                    return <span>{rowData.awb}</span>;
                  },
                },
                { title: 'Origin', field: 'org' },
                { title: 'Dest', field: 'dst' },
                { title: 'Pcs', field: 'pieces' },
                {
                  title: 'Weight',
                  field: 'weight',
                  render: (rowData: any) => {
                    return `${rowData.weight}K`;
                  },
                },
                { title: 'Specials', field: 'special' },
                { title: 'Remarks', field: 'remarks' },
              ]}
              actions={[
                (rowData: any) => ({
                  icon: () => (
                    <span>
                    <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachments_count }>
                      <AttachFile className={this.props.classes.actionMaterialIcon} />
                    </Badge>
                  </span>
                  ),
                  tooltip: 'Attach file',
                  onClick: (event, rowData: any) =>
                    this.props.openAttachments(rowData.awb, rowData.version),
                }),
                (rowData: any) => ({
                  icon: () => (
                    <Print className={this.props.classes.actionMaterialIcon} />
                  ),
                  tooltip: 'Print',
                  onClick: (event, rowData: any) =>
                    this.props.printAwbInfoClicked(rowData.awb, rowData.version),
                }),
              ]}
              options={{
                search: false,
                paging: false,
                showTitle: false,
                actionsColumnIndex: -1,
                toolbar: false,
                sorting: false,
                headerStyle: {
                  backgroundColor: 'var(--tbl_head_bkg)',
                  color: 'var(--tbl_head_color)',
                  zIndex: 2,
                },
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
    );
  }
  
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(AwbsTable));
